module.exports = __webpack_public_path__ + "static/media/Walker Audio Proscenium Black Diamond MK5 Turntable.e395c2f4.png";